<template>
	<div class="image-upload__container">
		<!-- Label -->
		<span v-if="!savedImageURI" class="image-upload__label-text">
			{{ $t('companion.imageUploadLabel') }}:
			<span v-if="mandatory" class="image-upload__mandatory">*</span>
		</span>

		<!-- Image upload -->
		<div v-if="!savedImageURI">
			<vue-anka-cropper
				:class="[
					hasError ? 'image-upload--error' : '',
					mandatory ? 'image-upload--mandatory' : ''
				]"
				:options="{
					croppedHeight: 552,
					croppedWidth: 600,
					cropperHeight: false,
					dropareaMessage: $t('companion.imageUploadRestrictions'),
					maxFileSize: false, //8000000
					resultMimeType: 'image/jpeg',
					selectButtonLabel: $t('companion.imageUploadButtonText'),
					showPreview: true,
					layoutBreakpoint: 450,
					skin: 'klappen'
				}"
				@cropper-saved="onSave($event)"
			></vue-anka-cropper>
			<div class="image-upload__description">
				<p>{{ $t('companion.imageUploadDescription') }}</p>
			</div>
		</div>

		<!-- Saved image -->
		<div v-if="savedImageURI" class="image-upload__image">
			<img :src="savedImageURI" />
			<Button size="small" @click.native="newImage">
				{{ $t('companion.imageUploadNew') }}
			</Button>
		</div>

		<!-- Error text -->
		<span
			class="image-upload__error"
			v-if="errorMessage != '' && !savedImageURI"
		>
			{{ errorMessage }}
		</span>
	</div>
</template>

<script>
import Button from '../../components/atoms/Button'
import vueAnkaCropper from 'vue-anka-cropper'

export default {
	name: 'ImageUpload',
	components: {
		Button,
		vueAnkaCropper
	},
	data() {
		return {
			savedImageURI: this.initalValue
		}
	},
	props: {
		mandatory: {
			type: Boolean,
			default: false
		},
		productMandatory: {
			type: Boolean,
			default: false
		},
		initalValue: {
			type: String,
			default: ''
		},
		value: {
			type: String,
			default: ''
		},
		errorMessage: {
			type: String,
			default: ''
		},
		hasError: {
			type: Boolean,
			default: false
		},
		isLoading: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		onSave(imgData) {
			this.savedImageURI = imgData.croppedImageURI
			this.$emit('image-save', this.savedImageURI)
		},
		newImage() {
			//Delete image (only in this component, not in guest) and show empty state
			this.savedImageURI = ''
			this.$emit('image-save', '')
		}
	}
}
</script>

<style lang="scss">
.image-upload {
	&__container {
		text-align: left;
	}
	&__mandatory {
		font-size: 15px;
		color: $colorRed;
		margin-left: -3px;
	}
	&__error {
		color: $colorRed;
		display: inline-block;
		font-size: 10px;
		line-height: 15px;
		margin-top: 10px;
		color: #e15b5b;
	}
	&__label {
		display: flex;
		position: relative;
		width: 100%;
		&--disabled {
			opacity: 0.5;
			pointer-events: none;
		}
		&-text {
			display: block;
			color: #697791;
			font-family: Saira;
			font-size: 15px;
			line-height: 24px;
			margin-bottom: 5px;
		}
	}
	&__image {
		height: auto;
		img {
			float: left;
			max-width: 150px;
			margin-right: 20px;
		}
	}
	&__description p {
		font-size: 12px;
		line-height: 1.2;
		font-style: italic;

		//Furillo overwrites
		margin-bottom: 0 !important;
	}
}

//Cropper skin
.ankaCropper.klappen {
	background: #fff;
	color: #697791;
	box-shadow: none;
	border-radius: 3px;
	font-family: Saira;
	font-size: 15px;
	line-height: 24px;
}
.ankaCropper.klappen .ankaCropper__droparea {
	border: 1px dashed #949eb1;
	margin: 0 0 10px 0;
	position: relative;
	background: #eee;
}
.vueAnkaCropper.image-upload--mandatory
	.ankaCropper.klappen
	.ankaCropper__droparea {
	border-color: #64c7bc;
}
.vueAnkaCropper.image-upload--error
	.ankaCropper.klappen
	.ankaCropper__droparea {
	border-color: #e15b5b;
}
.ankaCropper.klappen .ankaCropper__saveButton,
.ankaCropper.klappen .ankaCropper__selectButton {
	color: #ffffff;
	font-family: Saira;
	font-size: 13px;
	font-weight: 500;
	letter-spacing: 0;
	line-height: 25px;
	text-align: center;
	box-shadow: 0px 5px 10px -5px rgb(8 86 111 / 20%);
	text-shadow: 1px 1px rgb(0 0 0 / 10%);
	padding: 7px 30px;
	background-color: #59bdf6;
}
.ankaCropper.klappen .ankaCropper__saveButton:hover,
.ankaCropper.klappen .ankaCropper__selectButton:hover {
	background-color: #4ba1d3;
}
.ankaCropper.klappen .ankaCropper__navigation {
	background: #bfc5cf;
	padding: 12px 12px 2px 12px;
}
.ankaCropper.klappen .ankaCropper__navButton {
	border-radius: 0;
	background-color: #ffffff;
	box-shadow: none;
	margin-bottom: 10px;

	//Furillo overwrites
	-webkit-box-sizing: content-box;
	box-sizing: content-box;

	&:hover {
		background-color: #fff;
	}
}
.ankaCropper.klappen .ankaCropper__navButton svg {
	stroke: #000;
}
// .ankaCropper.klappen .ankaCropper__navButton svg {
// 	display: none;
// }
// .ankaCropper.klappen .ankaCropper__navButton:before {
// 	content: "";
// 	display: inline-block;
// 	background: url('../../assets/icons/upload@2x.png') 24px 24px no-repeat;
// 	width: 24px;
// 	height: 24px;
// }
.ankaCropper.klappen .ankaCropper__saveButton,
.ankaCropper.klappen .ankaCropper__navButton[title='Cancel'] {
	box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
	border-radius: 2px;
	height: auto;
	width: auto;
	float: none;
	display: inline-block;
	color: #ffffff;
	font-family: Saira;
	font-size: 13px;
	font-weight: 500;
	letter-spacing: 0;
	line-height: 18px;
	text-align: center;
	box-shadow: 0px 5px 10px -5px rgb(8 86 111 / 20%);
	text-shadow: 1px 1px rgb(0 0 0 / 10%);
	padding: 7px 30px;
	background-color: #59bdf6;
	margin-bottom: 10px;
	vertical-align: middle;
	svg {
		display: none;
	}
	&:hover {
		background-color: #4ba1d3;
		text-decoration: none;
	}
}
.ankaCropper.klappen .ankaCropper__navButton[title='Cancel'] {
	background-color: RGBA(116, 128, 151, 1);
	&:before {
		content: 'Cancel';
	}
	&:hover {
		background-color: RGBA(116, 108, 131, 1);
	}
}
.ankaCropper__mainArea {
	margin: 20px 0 0 0;
}
.ankaCropper__mainArea > div:not(.ankaCropper__previewArea) {
	//Furillo overwrites
	max-width: 100% !important;
	clear: none !important;
	margin: 0 !important;
}
.ankaCropper__previewArea {
	display: block;
	position: relative;
	//margin-top: 35px;
	text-align: left;

	//Furillo overwrites
	margin: 35px 0 0 0 !important;
	clear: none !important;
	max-width: none !important;
}
.ankaCropper__previewArea:before {
	display: block;
	position: absolute;
	top: -25px;
	left: 0;
	content: 'Förhandsvisning:';
}

@media only screen and (min-width: 530px) {
	.ankaCropper.klappen .ankaCropper__saveButton,
	.ankaCropper.klappen .ankaCropper__navButton[title='Cancel'] {
		float: right;
	}
	.ankaCropper.klappen .ankaCropper__navButton[title='Cancel'] {
		margin-left: 10px;
	}
	.ankaCropper__previewArea {
		//margin-left: 20px;

		//Furillo overwrites
		margin: 35px 0 0 20px !important;
		img {
			width: 100%;
		}
	}
}

@media only screen and (min-width: 640px) {
	.ankaCropper.klappen .ankaCropper__saveButton,
	.ankaCropper.klappen .ankaCropper__navButton[title='Cancel'] {
		float: none;
	}
	.ankaCropper.klappen .ankaCropper__navButton[title='Cancel'] {
		margin-left: 0;
	}
	.ankaCropper__previewArea {
		//Furillo overwrites
		margin: 35px 0 0 0 !important;
	}
}

@media only screen and (min-width: 920px) {
	.ankaCropper.klappen .ankaCropper__saveButton,
	.ankaCropper.klappen .ankaCropper__navButton[title='Cancel'] {
		float: right;
	}
	.ankaCropper.klappen .ankaCropper__navButton[title='Cancel'] {
		margin-left: 10px;
	}
	.ankaCropper__previewArea {
		//Furillo overwrites
		margin: 35px 0 0 20px !important;
		img {
			width: 100%;
		}
	}
}
</style>
